import React from 'react'
import { Button, FormControlLabel, Switch } from '@material-ui/core'
import { Typography } from '@material-ui/core';
import { Color, ColorPicker } from 'material-ui-color';
import { CustomThemeParams } from '../../themes/theme';

interface ICustomThemeBuilderProps {
    updateDisabled: boolean,
    editCustomThemeParams: CustomThemeParams,
    onUpdate: (params: CustomThemeParams) => void,
    onUpdateClicked: () => void
}

export default function CustomThemeBuilder({ updateDisabled, editCustomThemeParams, onUpdate, onUpdateClicked }: ICustomThemeBuilderProps) {

    function handleUpdateClicked() {
        onUpdateClicked()
    }

    function handleDarkModeChecked() {
        var newParams = { ...editCustomThemeParams }
        newParams.isDark = !newParams.isDark
        onUpdate(newParams)
    }

    function colorInputToColor(input: Color) {
        return `#${input.hex}`
    }

    function handlePrimaryChanged(color: Color) {
        var newParams = { ...editCustomThemeParams }
        newParams.primary = colorInputToColor(color)
        onUpdate(newParams)
    }

    function handleSecondaryChanged(color: Color) {
        var newParams = { ...editCustomThemeParams }
        newParams.secondary = colorInputToColor(color)
        onUpdate(newParams)
    }

    function handleBackgroundChanged(color: Color) {
        var newParams = { ...editCustomThemeParams }
        newParams.background = colorInputToColor(color)
        onUpdate(newParams)
    }

    return (
        <div style={{ width: '100%', marginTop: 8 }}>
            <Typography variant="subtitle1" style={{ marginBottom: 12 }}>Custom Theme Builder</Typography>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, alignItems: 'end' }}>
                <div>
                    <Typography variant="caption">Background</Typography>
                    <ColorPicker
                        value={editCustomThemeParams.background}
                        onChange={handleBackgroundChanged}
                        disableAlpha />
                </div>
                <div>
                    <Typography variant="caption">Primary</Typography>
                    <ColorPicker
                        value={editCustomThemeParams.primary}
                        onChange={handlePrimaryChanged}
                        disableAlpha />
                </div>
                <div>
                    <Typography variant="caption">Secondary</Typography>
                    <ColorPicker
                        value={editCustomThemeParams.secondary}
                        onChange={handleSecondaryChanged}
                        disableAlpha />
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8, flexWrap: 'wrap' }}>
                <FormControlLabel
                    control={<Switch
                        checked={editCustomThemeParams.isDark}
                        onChange={handleDarkModeChecked}
                        color="primary" />}
                    label="Dark Mode" />
                <Button
                    variant="contained"
                    color="primary"
                    disabled={updateDisabled}
                    onClick={handleUpdateClicked}>
                    Update
                </Button>
            </div>
        </div>
    )
}
